import { useForm as useFormHook } from "hooks";
import type { OnboardingMediaAndComplianceCheck as OnboardingMediaAndComplianceCheckType } from "features/ecommerce/types";
import {
    FormField,
    type OnboardingMediaAndComplianceCheck,
    type OnboardingMediaAndComplianceCheckForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = (
    {
        adverseMediaCoverageInput,
        legalInvestigationInput,
        registeredWithAuthorityInput,
        ...restInitialValues
    }: Partial<OnboardingMediaAndComplianceCheckType>
): OnboardingMediaAndComplianceCheck => ({
    [FormField.HasAdverseMediaCoverage]: null,
    [FormField.AdverseMediaCoverageInput]: adverseMediaCoverageInput ?? '',
    [FormField.HasLegalInvestigation]: null,
    [FormField.LegalInvestigationInput]: legalInvestigationInput ?? '',
    [FormField.HasCertification]: null,
    [FormField.IsCompliantWithTax]: null,
    [FormField.IsRegisteredWithAuthority]: null,
    [FormField.RegisteredWithAuthorityInput]: registeredWithAuthorityInput ?? '',
    ...restInitialValues
});

export const useForm = (onboardingMediaAndComplianceCheck: OnboardingMediaAndComplianceCheckForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingMediaAndComplianceCheck,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
